
import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <section className="relative h-screen flex items-center justify-center text-white overflow-hidden">
      {/* 背景動画 */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="https://videos.pexels.com/video-files/7578555/7578555-uhd_2560_1440_30fps.mp4" type="video/mp4" />
        <source src="https://videos.pexels.com/video-files/5524175/5524175-uhd_2560_1440_25fps.mp4" type="video/mp4" />
      </video>
      
      {/* オーバーレイ */}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      
      <div className="relative z-10 container mx-auto px-6 text-center">
        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
          地域に根ざし、人と街をつなぐ<br />
          不動産会社として。
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
          この街に住む人々の暮らしを支え、未来へと続く安心を届けます。
        </p>
        <button 
          onClick={() => document.getElementById('message-section')?.scrollIntoView({ behavior: 'smooth' })}
          className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer"
        >
          会社について詳しく見る
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
